import React from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import Input from '../components/Input';
import RadioGroup from '../components/RadioGroup';
import Select from '../components/Select';
import StackForm from '../components/StackForm';
import Title from '../components/Title';
import { click_next_step6, click_next_step7 } from '../techspec';

import useStore from '../store';

import { zonas, departamentos, localidades } from '../data';

const Department = props => {
  const { register, errors, watch, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const [{ mostrarReferidos }, setStore] = useStore();

  const onSubmit = data => {
    action(data);

    if (state?.data?.delivery === 'otra_direccion') {
      click_next_step6();

      if (mostrarReferidos) {
        props.history.push({ pathname: '/8', state: 'otra-direccion' });
      } else {
        props.history.push({ pathname: '/9', state: 'otra-direccion' });
      }
    } else {
      click_next_step7();

      props.history.push('/7');
    }
  };

  const selectedDepartment = watch('entrega_department') || state?.data?.entrega_department || '';

  const getLocalidades = department => {
    if (!department) return [];

    let localidadesOptions = [];

    localidades.filter(localidad => {
      if (localidad[1] === department) {
        localidadesOptions.push({ label: localidad[0], value: localidad[0] });
      }
    });

    return localidadesOptions;
  };

  const preventSpecialChars = event => {
    const regex = new RegExp('[A-Za-z0-9\\s ñ .]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  if (state?.data?.delivery === 'otra_direccion') {
    return (
      <StackForm onSubmit={handleSubmit(onSubmit)}>
        <div>
          <Title>Decinos la dirección donde querés recibir tu tarjeta.</Title>

          <Select
            id="entrega_department"
            name="entrega_department"
            label="Departamento"
            placeholder="Seleccioná tu departamento"
            options={departamentos}
            register={register({ required: 'Debe seleccionar un departamento.' })}
            error={errors.entrega_department}
            defaultValue={state?.data?.entrega_department || ''}
          />

          <Select
            id="entrega_localidad"
            name="entrega_localidad"
            label="Localidad"
            placeholder="Seleccioná tu localidad"
            disabled={!selectedDepartment}
            register={register({ required: 'Debe seleccionar una localidad.' })}
            options={getLocalidades(selectedDepartment)}
            error={errors.entrega_localidad}
            defaultValue={state?.data?.entrega_localidad || ''}
          />

          <Input
            id="entrega_address"
            name="entrega_address"
            label="Dirección"
            placeholder="Ingresá tu dirección"
            register={register({ required: 'Debe ingresar su dirección.' })}
            error={errors.entrega_address}
            defaultValue={state?.data?.entrega_address}
            onKeyPress={preventSpecialChars}
          />
        </div>

        <div className="form-actions">
          <Button block type="submit" id="next-button-step-6.1">
            Siguiente
          </Button>

          <BackButton />
        </div>
      </StackForm>
    );
  }

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>¿En dónde querés retirar tu tarjeta?</Title>

        <RadioGroup
          name="zona"
          variant="text"
          options={zonas}
          register={register({ required: 'Debe seleccionar una opción.' })}
          error={errors.zona}
          defaultChecked={state?.data?.zona}
        />
      </div>

      <div className="form-actions">
        <Button block type="submit" id="next-button-step-6.2">
          Siguiente
        </Button>

        <BackButton />
      </div>
    </StackForm>
  );
};

export default withRouter(Department);
